export const AiAgentSubMenuRoutes = {
  DEFAULT: '/web-assistant/theme',
  AI_ASSISTANT_FUNCTIONS: '/functions',
  AI_ASSISTANT_PAGES: '/web-assistant/pages',
  AI_ASSISTANT_MENU: '/web-assistant/menus-index/menu',
  AI_ASSISTANT_THEME: '/web-assistant/theme',
  ACCOUNT_APPEARANCE: '/web-assistant/appearance',
  APP_CREDENTIAL: '/web-assistant/credentials',
  AI_ASSISTANT_LOGS: '/logs',
  TRAIN_AI: '/ai-training',
  LIST_MENU: '/web-assistant/menus-index/list',
  AI_ASSISTANT_SERVICES_MENU: '/web-assistant/menus-index/services-menu',
  LANGUAGE_SETTINGS: '/language-settings',
  SHARE_LINK_SETTINGS: '/share',
  INTRO_MESSAGES: '/web-assistant/intro-messages',
  INDUSTRY_DATA: '/industry-data',
  FEEDBACK: '/feedback',
  IMAGE_TRAINING: '/image-training',
  VIDEO_TRAINING: '/video-training',
};
